export const COUNTRIES = [
  "Ethiopia", "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman", "Kenya", "Djibouti", "Somalia",
  "Sudan", "Eritrea", "Uganda", "Tanzania", "Rwanda", "Nigeria", "Ghana", "South Africa", "Egypt", "Morocco",
  "United States", "Canada", "United Kingdom", "Ireland", "Germany", "France", "Netherlands", "Belgium", "Switzerland", "Sweden",
  "Norway", "Denmark", "Finland", "Italy", "Spain", "Portugal", "Austria", "Poland", "Russia", "Turkey",
  "Israel", "Jordan", "Lebanon", "India", "Pakistan", "Bangladesh", "Sri Lanka", "China", "Hong Kong", "Singapore",
  "Malaysia", "Indonesia", "Philippines", "Japan", "South Korea", "Australia", "New Zealand", "Brazil", "Mexico", "Argentina",
];
